export const state = {
  createResponse: {},
  createBulkResponse: {},
}
